import { observable, action, makeObservable } from "mobx";
export class BonusesRetriever {
    constructor(options) {
        this.activate = () => {
            this.bonusDetailsSubscription = this.connection.subscribe({
                name: "BonusDetails",
                params: undefined,
                onData: this.onBonusDetailsData,
                onError: this.onBonusDetailsError,
            });
        };
        this.deactivate = () => {
            var _a;
            (_a = this.bonusDetailsSubscription) === null || _a === void 0 ? void 0 : _a.dispose();
            this.bonusDetailsSubscription = undefined;
        };
        this.onBonusDetailsData = (payload) => {
            const pendingDetails = this.pendingBonusDetails[payload.data.playerBonusId];
            this.updateBonusDetails(payload.data.playerBonusId, payload.data);
            if (typeof pendingDetails === "object") {
                pendingDetails.resolve(payload.data);
            }
            this.pendingBonusDetails[payload.data.playerBonusId] = undefined;
        };
        this.onBonusDetailsError = (payload) => {
            const pendingDetails = this.pendingBonusDetails[payload.data.playerBonusId];
            if (typeof pendingDetails === "object") {
                pendingDetails.reject(payload.data);
            }
            this.pendingBonusDetails[payload.data.playerBonusId] = undefined;
        };
        this.connection = options.connection;
        this.bonusDetails = observable.map(new Map());
        this.bonusDetailsSubscription = undefined;
        this.pendingBonusDetails = {};
        makeObservable(this, {
            updateBonusDetails: action.bound
        });
    }
    getBonusDetailsById(request) {
        if (typeof this.bonusDetailsSubscription === "undefined") {
            return Promise.reject({
                status: "ConnectionNotOpened",
            });
        }
        const bonusDetails = this.pendingBonusDetails[request.playerBonusId];
        if (typeof bonusDetails === "object") {
            return bonusDetails.promise;
        }
        const pendingDetails = {};
        pendingDetails.promise = new Promise((resolve, reject) => {
            pendingDetails.resolve = resolve;
            pendingDetails.reject = reject;
        });
        this.pendingBonusDetails[request.playerBonusId] = pendingDetails;
        this.bonusDetailsSubscription.send({
            method: "getBonusDetailsById",
            params: {
                playerBonusId: request.playerBonusId,
            }
        });
        return pendingDetails.promise;
    }
    updateBonusDetails(playerBonusId, bonusDetails) {
        this.bonusDetails.set(playerBonusId, bonusDetails);
    }
}
//# sourceMappingURL=BonusesRetriever.js.map